module.exports = __webpack_public_path__ + "media/images/articles/entry_steps/cover-c9c4a76013ec26f948989269e8224f0a.png";